export { INITIAL_DEALS as deals } from '../dealsData';

export const quickAccessDeals: Array<{
  dealId: string;
  name: string;
  isPinned?: boolean;
}> = [
  { dealId: 'deal-1', name: 'Sony Music Partnership', isPinned: true },
  { dealId: 'deal-5', name: 'Nike Brand Ambassador', isPinned: true },
  { dealId: 'deal-2', name: 'Netflix Sync License' },
];
